import { Box } from "@chakra-ui/react";
import { FastStartProductType } from "../../pages/membership";
import FastStartHeadLine from "./FastStartHeadline";
import FastStartProduct from "./FastStartProduct";

type FastStartProductsProps = {
  products: FastStartProductType[];
  headline: string;
};

const FastStartProducts = ({ products, headline }: FastStartProductsProps) => {
  const getProductBadgeColor = (badge: string) => {
    if (badge === "Purchased") {
      return "linear-gradient(97.66deg, #21C271 -6.61%, #039855 114%)";
    } else if (badge === "Free Bonus") {
      return "linear-gradient(97.66deg, #F79009 -6.61%, #DC6803 114%)";
    }

    return "linear-gradient(97.66deg, #7E7E7E -6.61%, #565656 114%)";
  };

  return (
    <>
      <FastStartHeadLine text={headline} />

      <Box background="#fff" borderRadius="18px" border="1px solid #EAECF0">
        {products.map((product, index) => {
          const borderBottom =
            index < products.length - 1 ? "1px solid #EAECF0" : "none";
          const badgeColor = getProductBadgeColor(product.badge);

          return (
            <FastStartProduct
              product={product}
              borderBottom={borderBottom}
              badgeColor={badgeColor}
              buttonClassName={product?.buttonClassName}
              key={product.title}
            />
          );
        })}
      </Box>
    </>
  );
};

export default FastStartProducts;
